/**
 * Formats a duration in seconds as `M:SS`, the format the design artefact's own time label uses.
 * Not `H:MM:SS`: clips are short enough that an hours segment is never needed.
 */
export function formatPlaybackTime(seconds: number): string {
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  return `${minutes}:${String(safeSeconds % 60).padStart(2, '0')}`;
}
